// @flow

import { Schema, arrayOf } from 'normalizr';

export const mappingByBundleIdSchema = new Schema('mappingByBundleId', { idAttribute: 'parentBundleId' });
export const inventoryBundleItemMappingListSchema = new Schema('inventoryBundleItemMappingList');
inventoryBundleItemMappingListSchema.define({
  inventoryBundleItemMappings: arrayOf(mappingByBundleIdSchema),
});
